<script lang="ts">
	import Advertising from '$lib/components/advertising/Advertising.svelte';
	import { getMapLayoutContext } from '$lib/components/map/map-layout-context';
	import { isMobile } from '$lib/services/mediaQuery/screenSize';

	const { drawerScrollPositionName } = getMapLayoutContext();

	let showAdContainer = $state(true);
</script>

{#if showAdContainer && $isMobile && $drawerScrollPositionName === 'opened'}
	<div class="flex justify-center sticky bottom-0 pb-2 pointer-events-none">
		<div class="pointer-events-auto">
			<Advertising
				adId="poi-list-banner"
				adFormat="320x100"
				showAdByDefault
				onAdAvailabilityChange={(isAvailable) => {
					showAdContainer = isAvailable;
				}}
			/>
		</div>
	</div>
{/if}
